import styled from 'styled-components';
import Button from 'components/Button';

export default styled(Button)`
  font-size: 13px;
  padding: 10px 25px;
`;
